module.exports = __webpack_public_path__ + "static/media/background-blue.2f41b0a3.png";